export default __webpack_public_path__ + "static/media/enable-opportunities.12ebffec.png";